import { HotelItem } from '@/app/types'
import { UTCDate } from '@date-fns/utc'
import axios from 'axios'
import { format } from 'date-fns'

const createKlaviyoEventBase = (email: string, metricName: string) => ({
	type: 'event',
	attributes: {
		time: format(new UTCDate(), "yyyy-MM-dd'T'HH:mm:ss"),
		unique_id: Date.now().toString(),
		metric: {
			data: {
				type: 'metric',
				attributes: {
					name: metricName,
				},
			},
		},
		profile: {
			data: {
				type: 'profile',
				attributes: {
					email: email,
				},
			},
		},
	},
})
const getFullUrl = (
	pathname: string,
	hotelTitle: string,
	hotelId: string,
	currency: string
) => {
	const pathParts = pathname.split('/')
	if (pathParts.length > 1) {
		pathParts.splice(2, 0, 'hotel')
	}
	const modifiedPathname = pathParts.join('/')
	const locationUrl = `${process.env.NEXT_PUBLIC_SITE_URL}${modifiedPathname}`
	return `${locationUrl}/${encodeURIComponent(
		hotelTitle
	)}?hotelID=${hotelId}&currency=${currency}`
}

const getHotelProperties = (hotel: HotelItem, fullUrl: string) => ({
	hotelName: hotel.title || '',
	hotelID: hotel.rawHotelData.id || '',
	price: hotel.rawPrice.toString(),
	currency: hotel.currency || 'USD',
	starRating: hotel.stars,
	image: hotel.image || '',
	location: hotel.location || '',
	guestRating: hotel.rawHotelData.guestRating?.toString() || '',
	hasFreeCancellation: hotel.rawHotelData.bestRate.hasFreeCancellation,
	noPrepayment: hotel.rawHotelData.bestRate.canPayLater,
	//TODO fix this before deploying new design to prod
	// benefitsText: hotel.benefitsText,
	locationUrl: fullUrl,
	availableRooms: hotel.rawHotelData.bestRate.availableRooms?.toString() || '',
	guestRatingSentiment: hotel.rawHotelData.guestRatingSentiment || '',
})

const sendKlaviyoEvent = async (data: any) => {
	try {
		const response = await axios.post(
			`${process.env.NEXT_PUBLIC_BACKEND_URL}/hotels/klavio-event?api-key=${process.env.NEXT_PUBLIC_API_KEY}`,
			data,
			{
				withCredentials: true,
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)
		console.log('Klaviyo event sent successfully:', response.data)
	} catch (error) {
		console.error('Error sending Klaviyo event:', error)
	}
}

export const sendKlaviyoViewCardEvent = async (eventData: {
	item: HotelItem
	email: string
	pathname: string
}) => {
	const { item, email, pathname } = eventData
	const fullUrl = getFullUrl(
		pathname,
		item.title,
		item.rawHotelData.id,
		item.currency
	)
	const baseEvent = createKlaviyoEventBase(email, 'view_card')
	const data = {
		data: {
			...baseEvent,
			attributes: {
				...baseEvent.attributes,
				value: item.rawPrice.toString(),
				value_currency: item.currency || 'USD',
				properties: getHotelProperties(item, fullUrl),
			},
		},
	}
	await sendKlaviyoEvent(data)
}

export const sendKlaviyoRecommendationsEvent = async (
	hotels: HotelItem[],
	email: string,
	pathname: string
) => {
	const freeCancellationHotels = hotels.filter(
		(hotel) => hotel.rawHotelData.bestRate.hasFreeCancellation
	)
	const restOfHotels = hotels.filter(
		(hotel) => !freeCancellationHotels.includes(hotel)
	)

	const allHotels = [...freeCancellationHotels, ...restOfHotels]
	const firstTwelveHotels = allHotels.slice(0, 12)

	const baseEvent = createKlaviyoEventBase(email, 'hotel_recommendations')

	const data = {
		data: {
			...baseEvent,
			attributes: {
				...baseEvent.attributes,
				properties: {
					recommendations: firstTwelveHotels.map((hotel) => {
						const fullUrl = getFullUrl(
							pathname,
							hotel.title,
							hotel.rawHotelData.id,
							hotel.currency
						)
						return getHotelProperties(hotel, fullUrl)
					}),
				},
			},
		},
	}
	await sendKlaviyoEvent(data)
}
